"use strict";

const PatientsListCtrl = function (PatientsService, CRUDService, config, $rootScope, $state, $stateParams, Notification) {
  let ctrl = this,
    currentPage = 0,
    totalPages,
    sortKey = '';

  ctrl.gender = {
    "MALE": 'männlich',
    "FEMALE": 'weiblich'
  };

  ctrl.model = {
    search: ''
  };

  ctrl.$onInit = function () {
    ctrl.activeSearch = false;
    ctrl.model.search = '';

    ctrl.request = PatientsService.getAll(sortKey, currentPage).then(function (data) {
      ctrl.patients = data.patients;
      totalPages = data.totalPages;

      //check if there is already a patient selection
      if ($stateParams.pid) {
        //Select patient to refresh medication & target lesions
        for (let patient of ctrl.patients) {
          if (patient.pid === $stateParams.pid) {
            $state.go("main.patients.list.details.treatsteps",
              {
                treatId: patient.treatments[0].uuid,
                treatment: patient.treatments[0],
                patient: patient,
                pid: patient.pid
              });
            break;
          }
        }
      }
    });
  };

  ctrl.getNextPage = function () {
    if ((currentPage + 1) < totalPages) {
      currentPage++;

      PatientsService.getAll(sortKey, currentPage).then(function (data) {
        ctrl.patients = ctrl.patients.concat(data.patients);
      });
    }
  };

  ctrl.hasIncompleteTreatments = function (treatments) {
    for (var treatment in treatments) {
      if (treatments.hasOwnProperty(treatment)) {
        for (var action in treatments[treatment].actions) {
          if (!treatments[treatment].actions[action].valid) {
            return true;
          }
        }
      }
    }

    return false;
  };

  ctrl.search = function (term) {
    ctrl.activeSearch = true;
    PatientsService.getAll(sortKey, currentPage, term).then(function (data) {
      ctrl.patients = data.patients;
      $rootScope.$broadcast('emil:patientsListChanged');
    });
  };

  ctrl.sort = function (key) {
    sortKey = !key ? undefined : key;
    currentPage = 0;

    PatientsService.getAll(sortKey, currentPage, ctrl.model.search).then(function (data) {
      ctrl.patients = data.patients;
    });
  };

  ctrl.requestDeletion = function (item) {
    item.popover = false;
    PatientsService.addPatientDeletionRequest({
      'pid': item.pid,
      'comment': ctrl.deleteMsg
    }).then(
      function () {
        Notification.success('Ihr Löschantrag wurde erfolgreich eingereicht und wird nun von dem Datentreuhänder bearbeitet.');
        ctrl.deleteMsg = undefined;
      },
      function () {
        Notification.error('Beim Einreichen des Löschantrags ist ein Fehler aufgetreten.');
      });
  };
};

PatientsListCtrl.$inject = ['PatientsService', 'CRUDService', 'config', '$rootScope', '$state', '$stateParams', 'Notification'];

module.exports = {
  template: require('./patients.html'),
  controller: PatientsListCtrl
};



// WEBPACK FOOTER //
// ./src/main/webapp-files/modules/patients/components/list-patients/patients.component.js